import PDFViewer from "../../../components/ui/PDFViewer";
import WebLayout from "../../../layouts/web";

export default function UserManual() {
  return (
    <WebLayout>
      <div className="container h-[calc(100vh-100px)] py-5">
        <PDFViewer fileUrl="/files/ManPowerX User Manual.pdf" />
      </div>
    </WebLayout>
  );
}
